/**
 * VTT — canvas map, grid, fog, draggable tokens, initiative, vault context.
 * Stub: scaffold for the highest-leverage page. Real implementation needs
 * the WebSocket client (src/lib/socket.ts, TBD) and a canvas layer.
 */
export default function Vtt() {
  return (
    <div>
      <h1>VTT</h1>
      <p className="sheet-b">Map canvas · tokens · fog · initiative tracker</p>
      <p>This page is a scaffold. Wire up the canvas + WebSocket layer next.</p>
    </div>
  );
}
